import { createContext, FC, useContext, useEffect, useMemo } from 'react';
import { useAccountDataQuery } from 'queries/account';

export const AntdRlUISwitcherContext = createContext<{
  isEnabled: boolean;
}>({
  isEnabled: false,
});

export const AntdRlUISwitcherProvider: FC<
  React.PropsWithChildren<{ forceOff?: boolean; forceEnable?: boolean }>
> = ({ children, forceOff, forceEnable: _forceEnable }) => {
  const { data: accountData } = useAccountDataQuery();
  const _isEnabled = accountData?.accountMeta?.features?.newUI ?? false;
  const isTesting = process.env.PLAYWRIGHT_TESTS;
  const forceEnable = isTesting ? true : _forceEnable;

  const isEnabled = (forceEnable ?? _isEnabled) && !forceOff;

  const value = useMemo(() => ({ isEnabled }), [isEnabled]);

  useEffect(() => {
    if (isEnabled) {
      document.documentElement.setAttribute('data-new-theme-enabled', 'true');
    } else {
      document.documentElement.removeAttribute('data-new-theme-enabled');
    }
  }, [isEnabled]);

  return (
    <AntdRlUISwitcherContext.Provider value={value}>
      {children}
    </AntdRlUISwitcherContext.Provider>
  );
};

export const useAntdRlUISwitcher = () => {
  const context = useContext(AntdRlUISwitcherContext);

  if (!context) {
    return false;
  }

  return context.isEnabled;
};
